import { deleteDB, IDBPDatabase, openDB } from 'idb';

export class ApiCache {
  private db: IDBPDatabase<unknown> | undefined = undefined;

  // The database name has the git commit hash in the name. So every new application
  // version gets a fresh db.
  private static dbNameSuffix = 'equinem-api-cache';
  // eslint-disable-next-line
  // @ts-ignore
  private static dbName = `${ApiCache.dbNameSuffix}-${GIT_COMMIT_HASH ?? 'no-commit-hash'}`;

  private static storeName = 'api-cache';

  private async loadDb(): Promise<IDBPDatabase<unknown>> {
    if (this.db) {
      return this.db;
    }

    const dbPromise = openDB(ApiCache.dbName, 1, {
      upgrade(db) {
        db.createObjectStore(ApiCache.storeName);
      },
    });
    dbPromise.then(db => {
      if (!this.db) {
        this.db = db;
      }
    });

    // Remove/Cleanup databases from different git commits.
    indexedDB.databases().then(allIdbs => {
      for (const db of allIdbs) {
        if (db.name && db.name !== ApiCache.dbName && db.name.startsWith(ApiCache.dbNameSuffix)) {
          deleteDB(db.name);
        }
      }
    });

    return dbPromise;
  }

  public async get(key: string): Promise<string | undefined> {
    return (await this.loadDb()).get<string>(ApiCache.storeName, key);
  }

  public async set(key: string, value: string): Promise<void> {
    await (await this.loadDb()).put(ApiCache.storeName, value, key);
  }

  public async remove(key: string): Promise<void> {
    return (await this.loadDb()).delete(ApiCache.storeName, key);
  }

  /**
   * Clears the cache by deleting all databases that start with the dbNameSuffix.
   */
  public static async clear(): Promise<void> {
    indexedDB.databases().then(allIdbs => {
      for (const db of allIdbs) {
        if (db.name && db.name.startsWith(ApiCache.dbNameSuffix)) {
          deleteDB(db.name);
        }
      }
    });
  }
}
